export default "__VITE_ASSET__BCD2IqkD__"